module.exports = __webpack_public_path__ + "static/media/athlete.a6c8fc10.svg";